export enum OperatingSystem {
  Android = 'android',
  IOS = 'ios',
  Other = 'other',
}
